import { Component, Input, OnChanges, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { ThemeServiceHelper } from 'common/theme/service.helper';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { VisitorInfoModel } from 'shared/models/visitor-info/visitor-info.model';
import { BcVisitorInfoBuilderService } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/services/visitor-info-builder.service';
import { isString } from 'lodash';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AvatarComponent implements OnChanges {
  @Input()
  workItemId: string;

  @Input()
  workItemType: string;

  @Input()
  title: string;

  visitor$: Observable<VisitorInfoModel>;

  constructor(private visitorInfoBuilder: BcVisitorInfoBuilderService,
              private _changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnChanges(): void {
    if (this.workItemType && this.workItemId) {
      this.visitor$ = this.visitorInfoBuilder.observeVisitorData(this.workItemId, this.workItemType);
      this._changeDetectorRef.detectChanges();
    }
  }

  get avatarThemeId(): string {
    return `${ThemeServiceHelper.getAvatarThemeId(this.workItemId)}`;
  }

  get isChat(): boolean {
    return this.workItemType === WorkItemTypes.CHAT;
  }

  get isComposeEmail(): boolean {
    return this.workItemType === WorkItemTypes.COMPOSE_EMAIL;
  }

  get isDiscussion(): boolean {
    return this.workItemType === WorkItemTypes.DISCUSSION;
  }

  get isPinvite(): boolean {
    return this.workItemType === WorkItemTypes.CHAT_PIN_INVITE;
  }

  get isChatOrPinvite(): boolean {
    return this.isChat || this.isPinvite;
  }

  get isTextChat(): boolean {
    return this.workItemType === WorkItemTypes.FACEBOOK || this.workItemType === WorkItemTypes.SMS ||
      this.workItemType === WorkItemTypes.ASYNC_MESSAGE;
  }

  getIconClass(): string {
    switch (this.workItemType) {
      case WorkItemTypes.EMAIL:
      case WorkItemTypes.COMPOSE_EMAIL:
        return 'mail-open';
      case WorkItemTypes.CHAT:
      case WorkItemTypes.CHAT_PIN_INVITE:
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
      case WorkItemTypes.DISCUSSION:
        return 'boldchat';
      default:
        throw new Error('Unknown work item type.');
    }
  }

  getInitials(): string {
    if (!this.title) {
      return null;
    }
    return this._createInitialsForAvatar(this.title);
  }

  private _createInitialsForAvatar(operatorName): string {
    if (isString(operatorName)) {
      const words = operatorName.toUpperCase().split(' ');
      let initial = '';
      words.forEach(value => {
        initial += value[0];
      });
      return initial;
    }
    return null;
  }
}
